var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { formatTotalValue } from "@/util/masks";
import { LoadedImage } from "./LoadedImage";
export function CodigoBarra(_a) {
    var data = _a.data;
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "flex flex-col justify-center gap-4" }, { children: [_jsxs("div", __assign({ className: "flex flex-col" }, { children: [_jsx("h1", __assign({ className: "text-center font-semibold text-xl leading-none" }, { children: "Escaneie o C\u00F3digo de Barras" })), _jsx("span", __assign({ className: "text-center text-lg" }, { children: "para pagar o Boleto" }))] })), _jsx("b", __assign({ className: "text-center text-lg" }, { children: formatTotalValue(data === null || data === void 0 ? void 0 : data.billet.totalValue) }))] })), _jsx(LoadedImage, { img: data === null || data === void 0 ? void 0 : data.billet.barCode.barCodeImage, className: "w-full" })] }));
}
